import React from "react";
import ReactHtmlParser from "react-html-parser";

function fixTableInner(inner) {
    if (!/<tr\b/i.test(inner)) {
        return inner;
    }

    let fixed = inner;
    const hasSection = /<(?:thead|tbody|tfoot)\b/i.test(fixed);

    if (!hasSection) {
        return `<tbody>${fixed}</tbody>`;
    }

    if (/^\s*<tr\b/i.test(fixed)) {
        fixed = fixed.replace(
            /^(\s*(?:<tr\b[\s\S]*?<\/tr>\s*)+)(?=<(?:thead|tbody|tfoot)\b|$)/i,
            "<tbody>$1</tbody>",
        );
    }

    fixed = fixed.replace(
        /(<\/(?:thead|tfoot)>)([\s\S]*?)(?=<(?:thead|tfoot)\b|$)/gi,
        (match, closingTag, between) => {
            const trimmed = between.trim();
            if (!trimmed || !/<tr\b/i.test(trimmed) || /<tbody\b/i.test(trimmed)) {
                return match;
            }
            return `${closingTag}<tbody>${between}</tbody>`;
        },
    );

    if (!/<tbody\b/i.test(fixed) && /<tr\b/i.test(fixed)) {
        return `<tbody>${fixed}</tbody>`;
    }

    return fixed;
}

function prepareHtml(msg) {
    if (!msg) {
        return msg;
    }
    let html = String(msg).replace(/>\s+</g, "><");
    let previousHtml;

    do {
        previousHtml = html;
        html = html.replace(
            /<table([^>]*)>([\s\S]*?)<\/table>/gi,
            (match, attrs, inner) => {
                if (/<table\b/i.test(inner)) {
                    return match;
                }
                return `<table${attrs}>${fixTableInner(inner)}</table>`;
            },
        );
    } while (html !== previousHtml);

    return html;
}

function ConvertStringToHtml(props) {
    return <>{ReactHtmlParser(prepareHtml(props.msg))}</>;
}

export default ConvertStringToHtml;
